export { CompanyLogo, type CompanyLogoProps } from "./components/logo/company-logo";
export { EducationLogo, type EducationLogoProps } from "./components/logo/education-logo";
export { CertificateLogo, type CertificateLogoProps } from "./components/logo/certificate-logo";
export {
  candidateLogoVariants,
  type CandidateLogoSize,
} from "./components/logo/logo-variants";
export {
  TechnicalProfileSection,
  type TechnicalProfileSectionProps,
} from "./components/technical-profile/technical-profile-section";
export { extractStackoverflowId } from "./lib/extract-stackoverflow-id";
export {
  CompanyCell,
  EmptyCell,
  JobTitleCell,
  NameCell,
  SelectCell,
  SelectHeader,
  SocialsCell,
  StageCell,
  fromArbitratorRow,
  fromPipelineCandidate,
  type CandidateCellRow,
  type ProfileCardLike,
} from "./components/table-cells";

// Boundary: features/candidate must NOT import from features/search, features/jobs,
// features/arbitrator, or components/search/*. Hosts in those features compose these
// primitives instead.
export {
  Profile,
  ProfileContext,
  useProfile,
  parseSpotlightMarkdown,
  type ProfileContextValue,
  type ProfileLayoutProps,
} from "./components/profile";
